/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Educational_Sciences24Inputs */

const en__field_enum_study_educational_sciences24 = /** @type {(inputs: _Field_Enum_Study_Educational_Sciences24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educational Sciences`)
};

const de__field_enum_study_educational_sciences24 = /** @type {(inputs: _Field_Enum_Study_Educational_Sciences24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erziehungswissenschaft`)
};

/**
* | output |
* | --- |
* | "Educational Sciences" |
*
* @param {_Field_Enum_Study_Educational_Sciences24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_educational_sciences24 = /** @type {((inputs?: _Field_Enum_Study_Educational_Sciences24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Educational_Sciences24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_educational_sciences24(inputs)
	return de__field_enum_study_educational_sciences24(inputs)
});
export { _field_enum_study_educational_sciences24 as "_field_enum_STUDY_EDUCATIONAL_SCIENCES" }